module.exports = __webpack_public_path__ + "static/img/file-link.961d1414.svg";